import React from 'react'
import { AppBar, Toolbar, Box } from '@mui/material'
import { Link } from 'react-router-dom'

export const Navbar = () => {
  return (
    <>
      <AppBar sx={{ color: '#000' }}>
        <Toolbar>
          <Box display='flex' justifyContent='space-between' width='100%'>
            <Box display='flex' align='center'>
              <Link to='/'>
                <Box pr={1}>
                  <img
                    src='client-static/images/Mobil_RGB_R-TM.png'
                    width={120}
                    height={65}
                    priority={true}
                  />
                </Box>
              </Link>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  )
}
